<template>
  <div class="box">
    <h4 class="title is-6">Hotspot Trend</h4>
    <canvas ref="canvasEl"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { Chart } from 'chart.js/auto'

const canvasEl = ref(null)
let chartInstance = null

onMounted(() => {
  chartInstance = new Chart(canvasEl.value, {
    type: 'line',
    data: {
      labels: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],
      datasets: [{
        label: 'Hotspots',
        data: [120, 190, 300, 250, 220, 310, 400],
        borderColor: '#ff3860',
        backgroundColor: 'rgba(255,56,96,0.2)',
        tension: 0.4,
        fill: true
      }]
    }
  })
})

onBeforeUnmount(() => {
  if (chartInstance) {
    chartInstance.destroy()
  }
})
</script>
